import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import { useTranslation } from '@/hooks/useTranslation';

// Importiere alle Sektionen
import HeaderSection from './HeaderSection';
import FeaturesSection from './FeaturesSection';
import FoundersSection from './FoundersSection';
import DevelopmentProcessSection from './DevelopmentProcessSection';
import BenefitsSection from './BenefitsSection';
import ContactForm from '@/components/common/ContactForm';

// Registriere die Übersetzungen
import translations from './translations';
import { registerTranslations } from '@/hooks/useTranslation';

// Registriere die Übersetzungen für diese Seite
registerTranslations('mobileAppsPage', translations);

const MobileAppsPage = () => {
  const { t } = useTranslation();
  
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo 
        title="Mobile App Entwicklung | iOS & Android Apps | React Native & Flutter"
        description="Professionelle Mobile App Entwicklung für iOS und Android. Native Apps, React Native, Flutter - von Kunden-Apps bis Business-Tools. Beratung, Entwicklung, App Store Launch."
        canonical="/mobile-apps"
      />
      <Layout>
        <main>
          {/* Mobile App Entwicklung */}
          <HeaderSection />                    {/* App-Entwicklung Hero */}
          <FeaturesSection />                  {/* App-Typen und Anwendungsfälle */}
          <FoundersSection />                  {/* Founders Section */}
          <DevelopmentProcessSection />        {/* Entwicklungsprozess */}
          <BenefitsSection />                  {/* Vorteile von Mobile Apps */}
          <ContactForm />                      {/* App-Beratung */}
        </main>
      </Layout>
    </>
  );
};

export default MobileAppsPage; 